import classNames from 'classnames';
import React from 'react';
import Icon from 'components/Icon';
import { useField, ErrorMessage } from 'formik';

const Text = ({
    label,
    icon,
    search,
    type,
    disabled,
    placeholder,
    helper,
    ...props
}) => {
    const [field, meta] = useField(props);
    return (
        <div className="form__group">
            <label className="form__label">
                {label}
                <div className="form__validation">
                    <input
                        className={classNames('form__input', {
                            'form__input--icon': icon,
                            'form__input--search': search,
                            'form__input--error': meta.touched && meta.error,
                        })}
                        type={type}
                        placeholder={placeholder}
                        disabled={disabled}
                        {...field}
                        {...props}
                    />
                    {icon && <Icon icon={icon} className="form__icon" />}
                    {search && (
                        <Icon
                            icon={'fa-solid fa-magnifying-glass'}
                            className="form__search"
                        />
                    )}
                    {helper && !meta.error && (
                        <div className="form__helper">{helper}</div>
                    )}
                    <ErrorMessage
                        name={field.name}
                        render={(msg) => (
                            <div className="form__helper">{msg}</div>
                        )}
                    />
                </div>
            </label>
        </div>
    );
};

export default Text;
